import React, { useState, useEffect } from "react";
import { Link,  Navigate} from "react-router-dom";
// import imgProductLakay from './images/md3.jpg';
import {activatorUserAdding, getAddressCountries} from "../../auth";
import { MdSmartphone} from "react-icons/md";
import { laguangeElakay } from "../../pageInside/dataElakay";
// import "./sliderProduct.css"
// import { Seller, } from "../../pageInside/Rolle"
import FormAddress from "../../pageInside/formInput/formAddress";

const AddAddressUserAssociate = (props) => {
    const {
        setPagesUser,
        bnTelephone,
        setUserInfo,
        token,
        infoSource,
        phoneUser,
        fullName
            } = props

            
    let userValue = {
        firstName: fullName.firstname? fullName.firstname : "",
        lastName:  fullName.lastname? fullName.lastname : "",
        shopName: null,
        tel: "",
        Address1: "", 
        Address2: "",
        city: '',
        State: '',
        postalCode: '',
        country: '',
        latitude: "",
        longitude: "",
        error: "",
    }

    const [values, setValues] = useState(userValue);
    const [allZipCodes, setAllZipCodes] = useState([])


     const loadCountries = (code, zipcode, page) => {
            getAddressCountries(code, zipcode).then(data => {
                if (data.error) {
                    console.log("data Not Found");
                } else {
                    if(!zipcode){
                        if(page !== "edit"){
                        userValue.country = code
                        setValues(userValue);
                        }
                    setAllZipCodes(data.zipCodes)
                    }else{
                        setValues({ ...values,
                            city: data.place,
                            State: data.state,
                            postalCode: data.zipcode,
                            latitude: data.latitude,
                            longitude: data.longitude,
                            error: false });
                    }
                }
            });
        };

    const clickSubmit = event => {

        event.preventDefault();
           
        activatorUserAdding(token, 'address',  values, true).then(data => {
            if (data.error) {
                setValues({ ...values, error: data.error });
            } else {
                setValues(userValue)
                setUserInfo(data)
                setPagesUser(bnTelephone)
            }
        });
    };

        return <FormAddress
                clickSubmit={clickSubmit}
                values ={values} 
                setValues={setValues}
                infoSource={infoSource}
                phoneUser={phoneUser}
                laguangeElakay ={laguangeElakay}
                setAllZipCodes={setAllZipCodes}
                allZipCodes={allZipCodes}
                loadCountries={loadCountries}
                btnCancel={false}
                />

   
};

export default AddAddressUserAssociate;
